import { useSelector } from 'react-redux';
import { fieldTypes } from '@/helpers/constants';

const noLangFields = [fieldTypes.CALENDAR, fieldTypes.DROPDOWN, fieldTypes.MULTI_SELECTION, fieldTypes.ACCORDION, fieldTypes.SWITCH, fieldTypes.INPUT_NUMBER,
  fieldTypes.CUSTOM_ARRAY, fieldTypes.INPUT_USER];
const findFields = [fieldTypes.MULTI_SELECTION, fieldTypes.INPUT_USER, fieldTypes.ACCORDION, fieldTypes.CUSTOM_ARRAY, fieldTypes.CHECKBOX];

const accessToChildren = (obj, paths) => paths.reduce((acc, curr) => (acc?.[curr] ?? false), obj);

const useWarningField = (fieldPath = [], fieldType, otherConditionInvalid) => {
  const { validations, changesCR, headerLanguage } = useSelector((state) => ({
    validations: state.campaignReducer.validations,
    changesCR: state.campaignReducer.changesFromVersion,
    headerLanguage: state.headerReducer.language || state.campaignReducer?.info?.defaultLanguage,
  }));
  const safeFieldPath = Array.isArray(fieldPath) ? [...fieldPath] : [];

  // if fields validations is active or view changes of campaign is active
  const [validationsActive, changesActive] = [validations?.active?.all, changesCR?.active];

  if (validationsActive) {
    const validationsPath = [...safeFieldPath];
    validationsPath.splice(1, 0, headerLanguage);
    let valid = accessToChildren(validations, validationsPath);
    valid = valid?.invalid ?? false;

    if (otherConditionInvalid) {
      return otherConditionInvalid.and ? valid && otherConditionInvalid.condition : valid || otherConditionInvalid.condition;
    }

    return valid;
  }

  if (changesActive) {
    const changesPath = [...safeFieldPath];
    const fieldsWithChanges = changesCR?.[changesPath.shift()];
    let fieldName = `${changesPath.join('.')}.${headerLanguage}`;

    if (noLangFields.includes(fieldType)) {
      fieldName = changesPath.join('.');
    }

    if (findFields.includes(fieldType)) {
      return fieldsWithChanges && fieldsWithChanges.find((field) => field?.includes(fieldName));
    }

    return fieldsWithChanges && fieldsWithChanges.find((field) => field === fieldName);
  }

  return false;
};

export default useWarningField;
